import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { AuthorizationInfoService } from '../services/authorization-info.service';
import { NotificationService } from '../services/notification.service';
import { UserService } from '../services/user.service';
import { getOrderIdFromRouteRecursive } from '../utils/ResolverUtil';

@Injectable({
    providedIn: 'root',
})
export class OrderWriteAccessGuard {
    constructor(
        private userService: UserService,
        private authorizationService: AuthorizationInfoService,
        private notificationService: NotificationService
    ) {}

    public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const orderId = getOrderIdFromRouteRecursive(route);
        if (orderId <= 0) {
            route.data = { ...route.data, canRead: false, canWrite: false };
            return true;
        }

        if (await this.userService.isLoggedIn()) {
            const info = await lastValueFrom(this.authorizationService.getAuthorizationInfo(orderId));

            route.data = { ...route.data, canRead: info.canRead, canWrite: info.canWrite };

            if (!info.canRead) {
                await this.notificationService.errorTranslate('COMMON.NOTALLOWED');
            }

            return true;
        } else {
            route.data = { ...route.data, canRead: false, canWrite: false };
            return false;
        }
    }
}
